// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yW-z","inlineTitle":"zW-z","sponsoredAdsWrapper":"AW-z","marketplaceRecosWrapper":"BW-z"};